var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSouthWest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.033 17.6777C62.7961 27.4408 62.7961 43.2699 53.033 53.033C43.2699 62.7961 27.4408 62.7961 17.6777 53.033C7.91456 43.2699 7.91456 27.4408 17.6777 17.6777C27.4408 7.91457 43.2699 7.91457 53.033 17.6777Z",
    fill: "#1a76d2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3617 44.7166L32.4656 23.4048C32.6054 22.9853 33.1809 22.9405 33.3841 23.3332L37.9353 32.1323C38.0779 32.4081 38.3027 32.6328 38.5785 32.7755L47.3775 37.3267C47.7703 37.5298 47.7254 38.1053 47.3059 38.2451L25.9941 45.3491C25.6032 45.4794 25.2314 45.1075 25.3617 44.7166Z",
    fill: "white",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouthWest);
export default __webpack_public_path__ + "static/media/south-west.68e37a70c6423494bf247b7f27b52a04.svg";
export { ForwardRef as ReactComponent };